import { useQuery } from "react-query";
import { getClassroom } from "../services/school/classroom/classroom";
import { PagedRequestType } from "../types/PagedResults";
import { Key_classroom } from "../utils/constants";

export const useGetClassroomQuery = (data: PagedRequestType, options:any= null) =>
  useQuery(
    [Key_classroom, JSON.stringify(data)],
    () => getClassroom(data), 
    options?{...options}:{}
  );